import React from 'react';
import { Employee as EmployeeModel } from '@models/Models';
import { Row, Col } from 'react-bootstrap';
import MyButton from '@components/MyButton';

interface EmployeeProps {
    item: EmployeeModel;
    onRemove: (id: string) => void;
    onEdit: (id: string) => void;
}

const EmployeeComp: React.FC <EmployeeProps> = ({ item, onRemove, onEdit }) => {
    return (
        <Row className='p-2 rounded-2 bg-white shadow myBorder mb-2'>
            <Col xs={1} className='d-flex justify-content-center align-items-center'>
                <img
                    src={require("@assets/icons/profile.png")}
                    alt=""
                    width={70}
                    height={70}
                />
            </Col>
            <Col>
                <h4 className='text-black'>{item.firstName} {item.lastName}</h4>
                <p className='text-black m-0'>Seit: {new Date(item.createdAt as string).toLocaleDateString()}</p>
                <p className='text-black m-0'>Handynummer: <strong>{item.phone}</strong></p>
                <p className='text-black m-0'>Email: <strong>{item.email}</strong></p>
            </Col>
            <Col xs={2} className='d-flex flex-column gap-2'>
                <MyButton
                    title='Bearbeiten'
                    disabled={false}
                    isSecundary={true}
                    onClick={() => onEdit(item.id as string)}
                />
                <MyButton
                    title='Löschen'
                    disabled={false}
                    isSecundary={false}
                    onClick={() => onRemove(item.id as string)}
                />
            </Col>
        </Row>
    )
}

export default EmployeeComp